import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { PropertyType } from '@hub4b/models/enums/property-type';
import { ColumnDefinition } from '@hub4b/models/server/column-definition';

@Component({
    selector: 'app-table-header-cell',
    templateUrl: './table-header-cell.component.html',
    styleUrls: ['./table-header-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatSortModule]
})
export class TableHeaderCellComponent {
    /** Déclaration des ENUM */
    public PropertyType = PropertyType;

    /**
     * Définition de la colonne affichée.
     */
    private _column: ColumnDefinition;

    @Input() disabledSort: boolean = false;

    @Input()
    public set column(value: ColumnDefinition) {
        this._column = value;
    }

    public get column(): ColumnDefinition {
        return this._column;
    }

    constructor() {}
}
